import { render, staticRenderFns } from "./AddServiceSaleReturn.vue?vue&type=template&id=c61c8fe2&scoped=true&"
import script from "./AddServiceSaleReturn.vue?vue&type=script&lang=js&"
export * from "./AddServiceSaleReturn.vue?vue&type=script&lang=js&"
import style0 from "./AddServiceSaleReturn.vue?vue&type=style&index=0&id=c61c8fe2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61c8fe2",
  null
  
)

export default component.exports